import { cn } from "@/lib/utils";

const MAP = {
  verified: { label: "Verified", cls: "text-[#2D3B32] bg-[rgba(45,59,50,0.08)] border-[rgba(45,59,50,0.2)]" },
  draft: { label: "Draft", cls: "text-[#7A5E2E] bg-[rgba(194,163,116,0.14)] border-[rgba(194,163,116,0.35)]" },
  source: { label: "Requires source", cls: "text-[#8C6A53] bg-[rgba(140,106,83,0.12)] border-[rgba(140,106,83,0.3)]" },
};

export const StatusBadge = ({ status = "draft", className }) => {
  const s = MAP[status] || MAP.draft;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 border px-2.5 py-1 font-mono-ss text-[0.62rem] tracking-widest uppercase",
        s.cls,
        className
      )}
      data-testid={`status-badge-${status}`}
    >
      <span className="h-1 w-1 rounded-full bg-current" aria-hidden />
      {s.label}
    </span>
  );
};

export default StatusBadge;
